import { createBrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ProtectedRoute } from "./authentication/components/ProtectedRoute";
import { protectedRoutes } from "./protectedRoutes";
import { publicRoutes } from "./public/publicRoutes";
import { RouteErrorScreen } from "./core/components/RouteErrorScreen";
import { NavBarLayout } from "./core/components/NavBarLayout";
import { RouteNotFoundScreen } from "./core/components/RouteNotFoundScreen";
import { ServerRoute } from "./core/components/ServerRoute";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        errorElement: <RouteErrorScreen />,
        children: [
            {
                index: true,
                lazy: () => import("./public/PublicIndex"),
            },

            {
                path: "login",
                lazy: () => import("./public/public-login/PublicLoginScreen"),
                errorElement: <RouteErrorScreen />,
            },

            { path: "set-up-your-profile", lazy: () => import("./profile/SetUpYourProfileScreen") },

            // NavBarLayout routes
            {
                element: <NavBarLayout />,

                errorElement: <RouteErrorScreen />,

                children: [
                    {
                        path: "public",
                        children: publicRoutes,
                        errorElement: <RouteErrorScreen title="This screen's not working right" />,
                    },

                    {
                        element: <ProtectedRoute />,
                        children: protectedRoutes,
                        errorElement: <RouteErrorScreen title="This screen's not working right" />,
                    },
                ],
            },

            { path: "api/*", element: <ServerRoute /> },

            // Catch all / 404
            { path: "*", element: <RouteNotFoundScreen /> },
        ],
    },
]);
